import { Link } from "react-router-dom";
import WorkCard from "@/components/feature/WorkCard";
import { works } from "@/mocks/works";

const updates = [
  works.find((w) => w.id === "daojishi")!,
  works.find((w) => w.id === "zuihouyiyefanzhuan")!,
  works.find((w) => w.id === "wuwuchengan")!,
  works.find((w) => w.id === "lianhuansaizheng")!,
  works.find((w) => w.id === "hongxie")!,
  works.find((w) => w.id === "pingxingzuian")!,
  works.find((w) => w.id === "jiyiliefeng")!,
  works.find((w) => w.id === "wujiedefangcheng")!,
];

export default function UpdatesSection() {
  return (
    <section
      id="updates"
      className="w-full border-y border-background-200/60 bg-background-100"
    >
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
              <i className="ri-time-line text-accent-400" aria-hidden="true"></i>
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              第一时间锁定最新话，追更不落后
            </p>
          </div>
          <Link
            to="/category/xuangyi"
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-300 transition-colors hover:text-accent-200"
          >
            查看全部
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
          {updates.map((w) => (
            <WorkCard key={w.id} work={w} />
          ))}
        </div>
      </div>
    </section>
  );
}